export enum UserType {
  CurrentOwner,
  Owner,
  InternalTeam,
}
